import { ITopic } from '../Interfaces/ITopic';

/** Anzeigename je Topic.ReferenceType. */
const REFERENCE_TYPE_LABELS: { [referenceType: string]: string } = {
  legaltransaction: 'Vorgänge',
  task: 'Aufgaben',
};

/** Unbekannte ReferenceTypes landen gesammelt hier — damit ein neu
 *  hinzugekommener Typ sichtbar wird statt zwischen den bekannten Gruppen
 *  zu verschwinden. */
export const FALLBACK_TOPIC_GROUP_LABEL = 'Weitere';

export interface ITopicGroup {
  label: string;
  topics: ITopic[];
}

/** Gruppiert Themen nach ReferenceType. Reihenfolge innerhalb einer Gruppe
 *  bleibt die der Eingabe; die Fallback-Gruppe steht immer am Ende. */
export const groupTopicsByReferenceType = (topics: ITopic[]): ITopicGroup[] => {
  const groups: ITopicGroup[] = [];
  const byLabel = new Map<string, ITopic[]>();

  topics.forEach(topic => {
    const label =
      REFERENCE_TYPE_LABELS[topic.ReferenceType] || FALLBACK_TOPIC_GROUP_LABEL;
    const bucket = byLabel.get(label);
    if (bucket) {
      bucket.push(topic);
    } else {
      const created = [topic];
      byLabel.set(label, created);
      groups.push({ label, topics: created });
    }
  });

  return [
    ...groups.filter(group => group.label !== FALLBACK_TOPIC_GROUP_LABEL),
    ...groups.filter(group => group.label === FALLBACK_TOPIC_GROUP_LABEL),
  ];
};

/** `{ [idTopic]: boolean }` → aufsteigende Liste der aktivierten idTopic. */
export const preferencesToOptions = (preferences: {
  [key: number]: boolean;
}): number[] =>
  Object.keys(preferences)
    .map(Number)
    .filter(idTopic => preferences[idTopic])
    .sort((a, b) => a - b);

/** Liste aktivierter idTopic → `{ [idTopic]: boolean }` über alle Themen.
 *  Jedes Thema wird explizit gesetzt, damit ein abgeschalteter Schalter nicht
 *  als "nie gesetzt" durchgeht. */
export const optionsToPreferences = (
  topics: ITopic[],
  options: number[]
): { [key: number]: boolean } =>
  topics.reduce(
    (acc, topic) => {
      acc[topic.idTopic] = options.includes(topic.idTopic);
      return acc;
    },
    {} as { [key: number]: boolean }
  );
